import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuthService from '../services/AuthService';

function LoginPage() {
  const { t } = useTranslation();
  const [deviceId, setDeviceId] = useState('');
  const [key, setKey] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  document.getElementsByTagName('body')[0].className = 'page-sidebar-hidden';

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      await AuthService.login(deviceId, key);
      window.location.href = '/';
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="login-page">
      <div className="container">
        <div className="row justify-content-md-center">
          <div className="col-md-12 col-lg-4">
            <div className="card login-box-container">
              <div className="card-body">
                <div className="authent-logo">
                  <img src={'./logo-kronix.png'} alt={t("login.logoAlt")} style={{ maxWidth: '100%' }} />
                </div>
                <div className="authent-text">
                  <p>{t("login.signInPrompt")}</p>
                </div>
                <form onSubmit={handleLogin}>
                  <div className="mb-3">
                    <div className="form-floating">
                      <input
                        type="text"
                        className="form-control"
                        id="floatingDeviceId"
                        placeholder={t("login.deviceId")}
                        value={deviceId}
                        onChange={(e) => setDeviceId(e.target.value)}
                      />
                      <label htmlFor="floatingDeviceId">{t("login.deviceId")}</label>
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="form-floating">
                      <input
                        type="password"
                        className="form-control"
                        id="floatingPassword"
                        placeholder={t("login.pin")}
                        value={key}
                        onChange={(e) => setKey(e.target.value)}
                      />
                      <label htmlFor="floatingPassword">{t("login.pin")}</label>
                    </div>
                  </div>
                  <div className="d-grid">
                    <button type="submit" className="btn btn-info m-b-xs">
                      {t("login.signIn")}
                    </button>
                  </div>
                </form>
                {error && (
                  <div className="authent-text" style={{ color: 'red' }}>
                    {error}
                  </div>
                )}
                <div className="authent-text" style={{ marginTop: '16px' }}>
                  <p>{t("login.newDevice")} <a href="/register" onClick={(e) => { e.preventDefault(); navigate('/register'); }}>{t("login.registerHere")}</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
